// components/reusable/Forms/UserAvatar.jsx
import React from "react";
import theme from "../../../styles/theme";

export default function UserAvatar({ name = "", size = 32 }) {
  const initials = name
    .split(" ")
    .map((n) => n[0]?.toUpperCase())
    .slice(0, 2)
    .join("");

  const palette = theme.getUserColor(name);

  const style = {
    backgroundColor: palette.background,
    color: palette.color,
    width: size,
    height: size,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: theme.fontWeights.medium,
    fontSize: size * 0.4,
  };

  return <div style={style}>{initials}</div>;
}
